import { post } from "../api";
import api from "../config/api";
import type {
  BusinessAdminApiResponse,
  BusinessDetailRecord,
  BusinessForm,
  BusinessItem,
} from "types/businessAdmin";

export type { BusinessDetailRecord };

export function mapBusinessDetailToItem(detail: BusinessDetailRecord | null): BusinessItem | null {
  if (!detail || detail.business_id === undefined || detail.business_id === null) return null;
  return {
    business_id: detail.business_id,
    name: detail.name ?? "",
    shortcode: detail.shortcode ?? "",
    address: detail.address ?? "",
    website: detail.website ?? "",
    tan: detail.tan ?? "",
    is_active: !!detail.is_active,
  };
}

export async function listBusinessesForAdmin(
  device_token: string,
  session_id: string
): Promise<BusinessAdminApiResponse<{ businesses?: BusinessItem[] }>> {
  return post<BusinessAdminApiResponse<{ businesses?: BusinessItem[] }>>(api.GET_BUSINESSES, {
    device_token,
    session_id,
  });
}

export async function getBusinessDetailForAdmin(
  business_id: string,
  device_token: string,
  session_id: string
): Promise<BusinessAdminApiResponse<{ business_detail?: BusinessDetailRecord }>> {
  return post<BusinessAdminApiResponse<{ business_detail?: BusinessDetailRecord }>>(
    api.GET_BUSINESS_DETAIL,
    {
      business_id,
      device_token,
      session_id,
    }
  );
}

export function newBusinessFormToCreatePayload(
  form: BusinessForm,
  device_token: string,
  session_id: string
) {
  return {
    name: form.name.trim(),
    shortcode: form.shortcode.trim(),
    address: form.address.trim(),
    website: form.website.trim(),
    tan: form.pan.trim().toUpperCase(),
    device_token,
    session_id,
  };
}

export function businessFormToUpdatePayload(
  item: BusinessItem,
  form: BusinessForm,
  device_token: string,
  session_id: string,
  is_active: boolean
) {
  return {
    business_id: item.business_id,
    name: form.name.trim(),
    shortcode: form.shortcode.trim(),
    address: form.address.trim(),
    website: form.website.trim(),
    tan: form.pan.trim().toUpperCase(),
    is_active,
    device_token,
    session_id,
  };
}

export function businessItemToStatusPayload(
  item: BusinessItem,
  is_active: boolean,
  device_token: string,
  session_id: string
) {
  return {
    business_id: item.business_id,
    name: item.name ?? "",
    shortcode: item.shortcode ?? "",
    address: item.address ?? "",
    website: item.website ?? "",
    tan: item.tan ?? "",
    is_active,
    device_token,
    session_id,
  };
}

export async function createOrUpdateBusiness(
  body: Record<string, unknown>
): Promise<BusinessAdminApiResponse<unknown>> {
  return post<BusinessAdminApiResponse<unknown>>(api.CREATE_BUSINESS, body);
}

export async function validateBusinessShortcode(
  shortcode: string,
  device_token: string,
  session_id: string
): Promise<BusinessAdminApiResponse<{ is_valid?: boolean }>> {
  return post<BusinessAdminApiResponse<{ is_valid?: boolean }>>(api.SHORTCODE_VALIDATION, {
    shortcode: shortcode.trim(),
    entity_type: "business",
    device_token,
    session_id,
  });
}
